(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["elements-decoder-lead-gate"] && !Shopify.designMode) return;
  try {
    (function(){
  var dialog=document.getElementById('ElementsDecoderLeadGate');
  if(!dialog)return;
  var form=dialog.querySelector('form');
  var status=dialog.querySelector('.ed-lead-gate__status');
  var success=dialog.querySelector('.ed-lead-gate__success');
  var pendingButton=null;
  var unlocked=localStorage.getItem('niamor_elements_unlocked')==='true';
  var selectors=['#nm-btn','#btn','.ed-btn'];
  function openGate(button){pendingButton=button||null;try{var y=parseInt((document.getElementById('ed-year')||{}).value,10);var m=parseInt((document.getElementById('ed-month')||{}).value,10);var d=parseInt((document.getElementById('ed-day')||{}).value,10);if(y&&m&&d){var ref=new Date(1900,0,1);var target=new Date(y,m-1,d);var diffDays=Math.round((target-ref)/86400000);var stemIdx=((diffDays%10)+10)%10;var stemEls=['\u6728','\u6728','\u706b','\u706b','\u571f','\u571f','\u91d1','\u91d1','\u6c34','\u6c34'];var ek=stemEls[stemIdx];var pages={'\u91d1':'/pages/your-metal-element-reading','\u6c34':'/pages/your-water-element-reading','\u6728':'/pages/your-wood-element-reading','\u706b':'/pages/your-fire-element-reading','\u571f':'/pages/your-earth-element-reading'};var rt=document.getElementById('ElementsDecoderReturnTo');if(rt&&pages[ek])rt.value=pages[ek];}}catch(e){}if(!dialog.open)dialog.showModal();}
  document.addEventListener('click',function(event){
    var button=event.target.closest(selectors.join(','));
    if(!button||unlocked||button.dataset.leadUnlocked==='true')return;
    event.preventDefault();event.stopImmediatePropagation();openGate(button);
  },true);
  dialog.querySelector('.ed-lead-gate__close').addEventListener('click',function(){dialog.close();});
  dialog.addEventListener('click',function(event){if(event.target===dialog)dialog.close();});
form.addEventListener('submit',function(event){try{localStorage.setItem('niamor_elements_unlocked','true');}catch(e){}status.textContent='Unlocking your elemental profile...';});
  document.addEventListener('mouseout',function(event){
    if(unlocked||sessionStorage.getItem('niamor_exit_prompt')||event.clientY>5||event.relatedTarget)return;
    sessionStorage.setItem('niamor_exit_prompt','true');openGate(null);
  });
})();
  } catch(e) { console.error(e); }
})();

})();
